import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';
import { AdjustmentBreakdownAdditionalStructure } from './AdjustmentBreakdownAdditionalStructure.tsx';

export const AdjustmentBreakdownAdditionalStructureManufactured = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <AdjustmentBreakdownAdditionalStructure
    {...props}
    breakdownCategory="manufactured"
    title="Manufactured Dwelling"
    id="isDepreciatedCostAdditionalImprovementsManufacturedInExport"
    summary={props}
  />
);
